import React from 'react';

export default props =>
    <svg className={`hamburger-button${props.expanded ? "--expanded" : ""}`} {...props}  width="20" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="3.2" rx="1" fill="#0F2A2B"/>
        <rect y="6.3999" width="20" height="3.2" rx="1" fill="#0F2A2B"/>
        <rect y="12.7998" width="16" height="3.2" rx="1" fill="#0F2A2B"/>
    </svg>